import PropTypes from "prop-types";
import React from "react";

import { Portal } from "../Portal";
import { Toast } from "../Toast";

import "./styles.scss";

export const Toaster = ({ onDismissButtonClick, portalRoot, toasts }) => {
  return (
    <Portal portalRoot={portalRoot}>
      <div className="apti-Toaster">
        {toasts.map((toast, index) => (
          <Toast
            dismissTimeout={toast.dismissTimeout}
            hideDismissButton={toast.hideDismissButton}
            hideReportButton={toast.hideReportButton}
            key={index}
            messageType={toast.messageType}
            onDismissButtonClick={onDismissButtonClick}
            onReportButtonClick={toast.onReportButtonClick}
            requestId={toast.requestId}
            toastId={toast.toastId}
          >
            {toast.message}
          </Toast>
        ))}
      </div>
    </Portal>
  );
};

Toaster.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  className: PropTypes.string,
  dismissMessage: PropTypes.string,
  hideDismissButton: PropTypes.bool,
  messageType: PropTypes.oneOf(["success", "success_v2", "warning", "error"]),
};

Toaster.defaultProps = {
  className: undefined,
  dismissMessage: "Dismiss",
  hideDismissButton: false,
  messageType: "success",
};
